import { InstrumentationCompose } from '../core/InstrumentationCompose'
import type { InstrumentationProvider } from '../core/Instrumentation'

/**
 * Composes multiple instrumentation providers into a single provider.
 * All method calls will be forwarded to each underlying provider.
 *
 * @param providers An array of InstrumentationProvider instances to compose.
 * @returns An InstrumentationCompose instance that delegates to all providers.
 */
export function composeAgents(
  ...providers: Array<InstrumentationProvider>
): InstrumentationCompose {
  return new InstrumentationCompose(providers)
}
